import SecondShoppingHeader from './SecondShoppingHeader';

export default SecondShoppingHeader;
